{
  "__localization_test_string": "{{time_period}} 동안 이 공급자에 대한 최대 방문 횟수에 도달했습니다. 다음에는 {{start_date}} 부터 이 제공업체를 방문할 수 있습니다.",
  "app_name": "Plentiful",
  "app_button_ok": "확인",
  "app_button_cancel": "취소",
  "app_button_yes": "예",
  "app_button_no": "아니요",
  "app_button_confirm": "확인하다",
  "app_button_try_again": "다시 시도하십시오",
  "rate_the_app": "Plentiful 평가하기",
  "app_textview_somethingwentwrong": "오류가 발생했습니다!\n다시 시도해 주세요",
  "app_button_logout": "로그 아웃",
  "app_today": "오늘",
  "app_dialog_clarify_prompt": "확실합니까?",
  "app_personal_edittext_phone": "전화 번호",
  "app_personal_edittext_dob": "생년월일 (선택 사항)",
  "app_personal_edittext_firstname": "이름",
  "app_personal_edittext_lastname": "성",
  "app_personal_edittext_zipcode": "우편 번호",
  "app_pantrykind_food": "식품 저장실",
  "app_servicekind_reservations": "전세",
  "app_servicekind_line": "라인",
  "distribution_schedule": "배포 일정",
  "service_type_no_digital_options": "줄서기만 가능",
  "service_type_reservation_inline": "예약 가능",
  "service_type_allows_pre_registration": "사전등록 가능",
  "app_locationnotavailable": "위치를 사용할 수 없습니다",
  "app_generalerror": "오류",
  "app_dialog_loading": "적재. 기다리세요…",
  "app_dialog_sms_code_title": "SMS 코드",
  "app_dialog_sms_code_button_send_new_code": "새 코드를 보냅니다",
  "app_release_id": "애플리케이션 릴리스 식별자",
  "sms_disclaimer": "메시지 및 데이터 요금이 부과될 수 있습니다. 수신 거부하려면 STOP을 보내세요.",
  "fragment_registration_language_textview_title": "시작하려면 원하는 언어를 선택하세요",
  "fragment_registration_language_button_next": "다음",
  "fragment_registration_family_textview_title": "귀하의 가정에 대해 알려주세요",
  "fragment_registration_family_textview_adults": "성인 수(18~{{senior_age_threshold_minus_one}}세)",
  "fragment_registration_family_textview_children": "자녀 수(18세 미만)",
  "fragment_registration_family_textview_seniors": "노인({{senior_age_threshold}}세 이상) 수",
  "fragment_registration_family_textview_notetitle": "메모:",
  "fragment_registration_family_textview_notecontent": "더 나은 서비스를 제공할 수 있도록 가구 정보를 제공해 주세요. 참고: 위에 기재하신 가구 구성원 수에 본인은 포함되지 않습니다.",
  "fragment_registration_family_button_back": "뒤",
  "fragment_registration_family_button_next": "다음",
  "fragment_registration_personal_textview_title": "풍부한 프로필에 오신 것을 환영합니다",
  "fragment_registration_personal_button_back": "뒤",
  "fragment_registration_personal_button_finish": "마치다",
  "fragment_main_tabitem_pantrymap": "지도",
  "fragment_main_tabitem_pantrylist": "목록",
  "fragment_main_bottombar_pantries": "팬티",
  "fragment_main_bottombar_visits": "방문",
  "fragment_main_bottombar_messages": "메시지",
  "fragment_main_bottombar_profile": "프로필",
  "cell_pantry_short_visit_date": "당신은 'reking.",
  "fragment_pantrydetail_button_changetime": "시간 변경",
  "fragment_pantrydetail_textview_amenities": "예의",
  "fragment_pantrydetail_textview_conditions": "정황",
  "fragment_pantrydetail_textview_notes": "식료품 저장실 메모",
  "fragment_pantrydetail_edittext_message": "메시지…",
  "fragment_pantrydetail_button_createreservation": "방문 예약",
  "fragment_pantrydetail_button_schedulevisit": "방문 일정",
  "dialog_visittime_textview_nodatesavailable": "날짜가 없습니다",
  "fragment_visitlist_textview_title": "방문",
  "fragment_visitlist_textview_zero": "이는 다가오는 서비스 시간을 관리 할 수있는 곳입니다. 방문을 예약하기 위해 식료품 저장실을 찾으십시오!",
  "fragment_messagethreadlist_textview_title": "메시지",
  "fragment_messagethreadlist_textview_zero": "아직 업데이트가 없습니다!\n업데이트를 구독하려면, 즐겨찾는 식료품 저장실의 세부 정보 페이지로 가서 페이지 하단에 있는 '이 식료품 저장실에서 업데이트 받기'를 선택하세요.",
  "fragment_profile_textview_title": "프로필",
  "fragment_profile_button_savechanges": "변경 사항을 저장하다",
  "fragment_profile_textview_personaldetails": "개인 정보",
  "fragment_profile_textview_language": "언어",
  "fragment_profile_textview_notifications": "알림",
  "fragment_profile_switch_receivenotifications": "푸시 알림",
  "receive_notifications_helper": "기기에서 알림 받기",
  "fragment_profile_textview_servicedetails": "서비스 세부 정보",
  "fragment_profile_switch_pickupfood": "다른 사람에게 내 음식을 가져가라고 부탁합니다",
  "fragment_profile_edittext_pickupname": "픽업 담당자 이름과 성",
  "fragment_profile_edittext_pickupphone": "픽업 담당자 전화번호",
  "textview_baby_supplies": "유아용품(기저귀, 물티슈, 분유)이 필요한 어린이 수는 몇 명입니까?",
  "fragment_profile_textview_emergencycontact": "긴급 연락처",
  "fragment_profile_edittext_emergencyname": "비상 연락처 이름과 성",
  "fragment_profile_edittext_emergencyphone": "비상연락전화",
  "aiq_validation_error_regex_telephone_us": "전화번호 형식이 잘못되었습니다.",
  "fragment_profile_textview_changepersonalinfo": "이 정보는 풍부한 식품 저장실에서 업데이트 될 수 있습니다.",
  "fragment_profile_edittext_feedback": "피드백…",
  "fragment_profile_toast_feedbacksent": "피드백 보내기",
  "baby_supplies": "유아용품",
  "household_size": "가구 규모",
  "food_pickup": "음식 픽업",
  "emergency_contact": "긴급 연락처",
  "dialog_app_update_title": "업데이트 가능",
  "dialog_app_update_message": "앱의 다음 버전은 Google Play 스토어에서 사용할 수 있습니다!",
  "dialog_app_update_button_openplaystore": "오픈 플레이 스토어",
  "app_invalid_error": "유효하지 않은",
  "no_pantries_available": "검색 결과가 없습니다. 다른 식료품 저장실 이름으로 검색해 보시거나, 검색창을 비우고 지도를 이동하거나 확대하여 Plentiful 식료품 저장실이 있는 지역을 살펴보세요.",
  "visit_served": "봉사하다",
  "visit_not_served": "제공되지 않습니다",
  "visit_no_show": "당신은 나타나지 않았습니다",
  "visit_group": "{{group_number}}그룹에 속해 있습니다. {{time}}로 오세요",
  "visit_pre_registered": "사전등록하셨습니다. {{from_time}} - {{end_time}}사이의 줄에 참여하세요.",
  "pick_visit_time": "방문 시간을 선택하십시오",
  "received_service_on": "다음 날짜에 방문하셨습니다.",
  "service_starts_at": "서비스가 시작됩니다",
  "cancel_visit": "방문 취소",
  "confirm_cancel_visit": "방문을 취소하고 싶습니까?",
  "yes_cancel": "예, 취소",
  "send": "보내다",
  "reservations_available": "방문을 예약할 수 있을 때 알려주세요",
  "service_notification_error": "알림 설정을 업데이트하는 중 문제가 발생했습니다. 다시 시도해 주세요. 여전히 문제가 있으신가요? 프로필을 탭한 후 도움이 필요하세요를 탭하여 지원팀에 문의하세요.",
  "report_location_issue": "이 위치의 문제 신고",
  "registration_intro": "Plentiful에 오신 것을 환영합니다! 가까운 푸드 뱅크를 찾으실 수 있도록 도와드리겠습니다.",
  "app_personal_edittext_enter_phone": "전화 번호를 입력하십시오",
  "code_sent_to": "SMS 로그인 코드가 다음으로 전송되었습니다.",
  "account_created": "계정 생성됨",
  "get_started": "시작해 볼까요!",
  "additional_details": "추가 정보",
  "your_qr_code": "당신의 능동적 인 패스",
  "id_number": "ID 번호",
  "personal_details_extra": "개인 정보 및 환경 설정",
  "settings": "설정",
  "settings_extra": "언어 및 알림 설정",
  "not_verified": "아직 확인되지 않았습니다",
  "must_be_reverified_by": "재확인해야합니다",
  "last_verified_on": "마지막으로 확인되었습니다",
  "at": "~에",
  "no_visit_options_available": "지금은 이용 가능한 방문 옵션이 없습니다. 식품 저장실 상태를 확인하시거나 식품 저장실에 문의하시기 바랍니다.",
  "need_help": "도움이 필요하다?",
  "email": "이메일",
  "terms_conditions": "최종 사용자 계약",
  "privacy_policy": "개인 정보 정책",
  "updates": "업데이트",
  "family_details": "가구 세부 정보",
  "welcome_to_plentiful": "풍부하게 환영합니다!",
  "enter_email_phone": "가입하시면 방문하시는 푸드 팬트리에 대한 예약을 하고 업데이트를 받아보실 수 있습니다.\n푸드 팬트리에 등록하셨다면, 동일한 전화번호나 이메일을 사용하세요. \n도움이 필요하신가요? support@plentiful.org로 문의해 주세요.",
  "email_or_phone": "휴대폰 번호 또는 이메일 주소",
  "email_address": "이메일 주소",
  "enter_email": "이메일을 입력하십시오",
  "address": "주소",
  "email_invalid": "이메일 주소가 유효하지 않습니다",
  "no_sms_enabled_phone": "전화번호로 문자 메시지를 받을 수 없습니다.",
  "verification_email_sent": "확인 이메일을 보냈습니다!",
  "check_verification_email": "이메일을 확인하고 안에 있는 버튼을 클릭하여 계정을 확인하세요.",
  "email_verification_sent": "이메일을 보내드렸습니다. 이메일에 있는 버튼을 클릭하여 이메일 주소를 확인해 주세요.",
  "email_address_purpose": "Plentiful의 방문 알림과 중요한 업데이트를 받으려면",
  "sign_up": "가입하기",
  "sign_in": "로그인",
  "continue": "계속하다",
  "create_password": "암호를 만듭니다",
  "enter_password": "로그인 할 비밀번호를 입력하십시오",
  "password_info_box": "비밀번호를 잊으셨거나 비밀번호를 설정하지 않고 식품 저장실에 등록하신 경우, 아래 옵션을 이용하여 매직으로 로그인하거나 비밀번호를 재설정하시기 바랍니다.",
  "reset_password": "암호를 재설정",
  "password": "비밀번호",
  "eight_characters": "적어도 8 자",
  "one_special_character": "적어도 1 개의 특수 문자",
  "one_number": "적어도 하나의 숫자",
  "submit": "제출하다",
  "send_magic_link": "매직 링크 보내기",
  "magic_link_sent": "마법 링크가 당신의 받은 편지함으로 가고 있습니다.",
  "confirm_magic_link_login": "매직링크 로그인 확인",
  "sign_in_another_way": "다른 방법으로 서명하십시오",
  "enter_phone": "전화 번호를 입력하십시오",
  "skip": "건너뛰다",
  "optional": "선택 과목",
  "enter_activation_code": "로그인 코드를 입력하세요",
  "activation_code": "로그인 코드",
  "accept_eula": "나는 이용 약관 및 개인 정보 보호 조건을 읽고 동의합니다.",
  "email_verified": "확인 된 이메일",
  "email_verified_details": "이메일 주소가 이제 확인되었습니다.",
  "do_not_ask_again": "다시 묻지 마세요.",
  "email_in_use": "우리는 이미이 이메일과 관련된 계정이 있습니다. 다른 이메일을 사용하십시오",
  "reset_password_text": "암호를 재설정하려면 이메일을 입력하십시오",
  "reset_password_sent": "reset password 이메일 전송!",
  "reset_password_sent_text": "{{email}} 에 대한 파일에 계정이있는 경우 암호를 재설정하기위한 링크를 보냈습니다.",
  "dob_required": "생일",
  "please_verify": "귀하의 프로필에서 전화 또는 이메일을 확인하십시오",
  "open_profile": "열린 프로필",
  "send_another_verification_email": "다른 확인 이메일을 보내십시오",
  "need_to_change_email": "이메일 주소를 변경해야 하는 경우 support@plentifulapp.com으로 문의하세요.",
  "need_to_change_email_or_phone": "이메일 주소나 전화번호를 변경해야 하는 경우 support@pletifulapp.com으로 문의하세요.",
  "need_to_change_phone": "전화 번호를 변경 해야하는 경우 support@plentifulapp.com으로 문의하거나 식료품 저장실을 방문하십시오.",
  "email_subscription": "이메일 구독",
  "email_subscribed": "이메일을 구독했습니다",
  "email_unsubscribed": "이메일 수신 거부",
  "email_subscribed_text": "이제 {{email}} 가 등록 된 이메일에 가입했습니다.",
  "email_unsubscribed_text": "이제는 풍부한 이메일로부터 {{email}} uncubscribed 됨으로써",
  "here_to_subscribe": "풍부한 이메일을 구독하려면 여기를 클릭하십시오",
  "here_to_unsubscribe": "풍부한 이메일에서 탈퇴하려면 여기를 클릭하십시오",
  "unsubscribe": "탈퇴",
  "subscribe": "구독하다",
  "open_profile_text": "프로필로 이동하려면 여기를 클릭하십시오",
  "sign_in_text": "로그인하려면 여기를 클릭하십시오",
  "phone_assigned": "이 전화 번호는 이미 사용 중입니다. 다른 전화 번호를 입력하거나 뒤로 가서이 전화 번호로 로그인하십시오.",
  "email_subscribe": "이메일 업데이트",
  "email_subscribe_helper": "방문하는 식료품 저장소와 Plentiful의 이메일",
  "message_preferences": "메시지 기본 설정",
  "message_preferences_description": "방문 알림과 업데이트를 어떻게 받으시겠습니까?",
  "message_method_option_0": "이메일 및 앱 알림",
  "message_method_option_1": "SMS 선호",
  "message_method_helper_add_phone": "SMS 메시지를 받으려면 전화번호를 추가하세요",
  "message_method_helper_sms_opt_in": "SMS를 다시 받으려면 PANTRY (726-879)로 'START'를 보내세요",
  "message_method_helper_add_email": "이메일 메시지를 받으려면 이메일을 추가하세요",
  "message_method_helper_email_unsub": "이메일 구독을 취소했습니다. 이메일을 받으려면 이메일 설정을 업데이트하세요.",
  "message_method_helper_add_push": "푸시 알림을 받으려면 모바일 앱을 다운로드하세요",
  "message_method_helper_enable_push": "푸시 알림을 받으려면 기기 설정에서 알림을 활성화하세요",
  "password_error": "잘못된 비밀번호. 다시 시도하거나 암호를 재설정하거나 다른 방법으로 로그인하십시오.",
  "action_required": "필요한 조치",
  "otp_error": "코드를 확인할 수 없습니다",
  "show_more": "자세히보기",
  "pre_registration": "등록",
  "show_less": "더 적은 것을 보여줍니다",
  "reschedule": "재조정",
  "view_pantry": "식료품 저장실 세부 정보 보기",
  "next_service_on": "다음 서비스 on.",
  "add_birthday": "Plenti-Pass를 잠금 해제하려면 생일을 입력하세요",
  "birthday_required": "이 패스를 사용하면 식료품 저장실에서 빠르고 쉽게 체크인할 수 있습니다.",
  "missed_reservation_on": "예약을 누락했습니다",
  "delete_account": "계정 삭제",
  "delete_explain": "정말로 계정을 삭제하시겠습니까? 그러면 예정된 모든 식료품 저장실 방문이 취소되고 계정이 삭제됩니다. Plentiful을 사용하려면 다시 등록해야 합니다.",
  "yes_delete": "예, 삭제",
  "no_cancel": "아니, 취소",
  "select_visit_reschedule": "일정 변경하려는 방문을 선택하십시오",
  "select_visit_cancel": "취소하려는 방문을 선택하십시오",
  "search_pantries": "팬티를 검색하십시오",
  "please_sign_in_or_up": "당신은 계속 될 풍요로운 계정이 필요합니다. 풍부한 것은 완전히 자유롭게 사용할 수 있습니다.",
  "sign_in_or_up": "계속하려면 로그인 또는 가입하십시오",
  "country_of_birth_option_AF": "아프가니스탄",
  "country_of_birth_option_AX": "Åland 제도",
  "country_of_birth_option_AL": "알바니아",
  "country_of_birth_option_DZ": "알제리",
  "country_of_birth_option_AS": "미국 사모아",
  "country_of_birth_option_AD": "안도라",
  "country_of_birth_option_AO": "앙골라",
  "country_of_birth_option_AI": "앵 귈라",
  "country_of_birth_option_AQ": "남극",
  "country_of_birth_option_AG": "안티구아와 바부 다",
  "country_of_birth_option_AR": "아르헨티나",
  "country_of_birth_option_AM": "아르메니아의",
  "country_of_birth_option_AW": "아루바",
  "country_of_birth_option_AU": "호주",
  "country_of_birth_option_AT": "오스트리아",
  "country_of_birth_option_AZ": "아제르바이잔",
  "country_of_birth_option_BS": "바하마",
  "country_of_birth_option_BH": "바레인",
  "country_of_birth_option_BD": "방글라데시",
  "country_of_birth_option_BB": "바베이도스",
  "country_of_birth_option_BY": "벨라루스",
  "country_of_birth_option_BE": "벨기에",
  "country_of_birth_option_BZ": "벨리즈",
  "country_of_birth_option_BJ": "베냉",
  "country_of_birth_option_BM": "버뮤다",
  "country_of_birth_option_BT": "부탄",
  "country_of_birth_option_BO": "볼리비아",
  "country_of_birth_option_BA": "보스니아 헤르체고비나",
  "country_of_birth_option_BW": "보츠와나",
  "country_of_birth_option_BV": "Bouvet Island.",
  "country_of_birth_option_BR": "브라질",
  "country_of_birth_option_IO": "영국 인도양 영토",
  "country_of_birth_option_BN": "브루나이 Darussalam.",
  "country_of_birth_option_BG": "불가리아",
  "country_of_birth_option_BF": "부키 나 파소",
  "country_of_birth_option_BI": "부룬디",
  "country_of_birth_option_KH": "캄보디아",
  "country_of_birth_option_CM": "카메룬",
  "country_of_birth_option_CA": "캐나다",
  "country_of_birth_option_CV": "케이프 베르데",
  "country_of_birth_option_KY": "케이맨 제도",
  "country_of_birth_option_CF": "중앙 아프리카 공화국",
  "country_of_birth_option_TD": "차드",
  "country_of_birth_option_CL": "칠레",
  "country_of_birth_option_CN": "중국",
  "country_of_birth_option_CX": "크리스마스 섬",
  "country_of_birth_option_CC": "코코스 (Keeling) 섬",
  "country_of_birth_option_CO": "콜롬비아",
  "country_of_birth_option_KM": "코모로스",
  "country_of_birth_option_CG": "콩고",
  "country_of_birth_option_CD": "콩고, 민주 공화국",
  "country_of_birth_option_CK": "쿡 제도",
  "country_of_birth_option_CR": "코스타리카",
  "country_of_birth_option_CI": "코트 D 'Ivoire.",
  "country_of_birth_option_HR": "크로아티아",
  "country_of_birth_option_CU": "쿠바",
  "country_of_birth_option_CY": "키프로스",
  "country_of_birth_option_CZ": "체코 공화국",
  "country_of_birth_option_DK": "덴마크",
  "country_of_birth_option_DJ": "지부티",
  "country_of_birth_option_DM": "도미니카",
  "country_of_birth_option_DO": "도미니카 공화국",
  "country_of_birth_option_EC": "에콰도르",
  "country_of_birth_option_EG": "이집트",
  "country_of_birth_option_SV": "엘살바도르",
  "country_of_birth_option_GQ": "적도 기니",
  "country_of_birth_option_ER": "eritrea.",
  "country_of_birth_option_EE": "에스토니아",
  "country_of_birth_option_ET": "에티오피아",
  "country_of_birth_option_FK": "포클랜드 제도 (말바나스)",
  "country_of_birth_option_FO": "페로 제도",
  "country_of_birth_option_FJ": "피지",
  "country_of_birth_option_FI": "핀란드",
  "country_of_birth_option_FR": "프랑스",
  "country_of_birth_option_GF": "프랑스 령 기아나",
  "country_of_birth_option_PF": "프랑스 령 폴리네시아의",
  "country_of_birth_option_TF": "프랑스 남부 영토",
  "country_of_birth_option_GA": "가봉",
  "country_of_birth_option_GM": "감비아",
  "country_of_birth_option_GE": "그루지야",
  "country_of_birth_option_DE": "독일",
  "country_of_birth_option_GH": "가나",
  "country_of_birth_option_GI": "지브롤터",
  "country_of_birth_option_GR": "그리스",
  "country_of_birth_option_GL": "그린란드",
  "country_of_birth_option_GD": "그레나다",
  "country_of_birth_option_GP": "과들루프",
  "country_of_birth_option_GU": "괌",
  "country_of_birth_option_GT": "과테말라",
  "country_of_birth_option_GG": "건지",
  "country_of_birth_option_GN": "기니",
  "country_of_birth_option_GW": "기니 비사우",
  "country_of_birth_option_GY": "가이아나",
  "country_of_birth_option_HT": "아이티",
  "country_of_birth_option_HM": "들었던 섬과 맥도날드 제도들",
  "country_of_birth_option_VA": "거룩한보기 (바티칸 시티 상태)",
  "country_of_birth_option_HN": "온두라스",
  "country_of_birth_option_HK": "홍콩",
  "country_of_birth_option_HU": "헝가리",
  "country_of_birth_option_IS": "아이슬란드",
  "country_of_birth_option_IN": "인도",
  "country_of_birth_option_ID": "인도네시아",
  "country_of_birth_option_IR": "이란, 이슬람 공화국",
  "country_of_birth_option_IQ": "이라크",
  "country_of_birth_option_IE": "아일랜드",
  "country_of_birth_option_IM": "아일 맨",
  "country_of_birth_option_IL": "이스라엘",
  "country_of_birth_option_IT": "이탈리아",
  "country_of_birth_option_JM": "자메이카",
  "country_of_birth_option_JP": "일본",
  "country_of_birth_option_JE": "저지",
  "country_of_birth_option_JO": "요르단",
  "country_of_birth_option_KZ": "카자흐스탄",
  "country_of_birth_option_KE": "케냐",
  "country_of_birth_option_KI": "키리바시",
  "country_of_birth_option_KP": "한국, 민주주의 사람들의 공화국",
  "country_of_birth_option_KR": "대한민국",
  "country_of_birth_option_KW": "쿠웨이트",
  "country_of_birth_option_KG": "키르기스스탄",
  "country_of_birth_option_LA": "라오스 사람들의 민주주의 공화국",
  "country_of_birth_option_LV": "라트비아",
  "country_of_birth_option_LB": "레바논",
  "country_of_birth_option_LS": "레소토",
  "country_of_birth_option_LR": "라이베리아",
  "country_of_birth_option_LY": "리비아 아랍 Jamahiriya.",
  "country_of_birth_option_LI": "리히텐슈타인",
  "country_of_birth_option_LT": "리투아니아",
  "country_of_birth_option_LU": "룩셈부르크",
  "country_of_birth_option_MO": "마카오",
  "country_of_birth_option_MK": "마케도니아, 전 유고 슬라브 공화국",
  "country_of_birth_option_MG": "마다가스카르",
  "country_of_birth_option_MW": "말라위",
  "country_of_birth_option_MY": "말레이시아",
  "country_of_birth_option_MV": "몰디브",
  "country_of_birth_option_ML": "말리",
  "country_of_birth_option_MT": "몰타",
  "country_of_birth_option_MH": "마샬 군도",
  "country_of_birth_option_MQ": "마르티니크",
  "country_of_birth_option_MR": "모리타니",
  "country_of_birth_option_MU": "모리셔스",
  "country_of_birth_option_YT": "마요네트",
  "country_of_birth_option_MX": "멕시코",
  "country_of_birth_option_FM": "미크로네시아, 페더레이션 된 상태",
  "country_of_birth_option_MD": "몰도바, 공화국",
  "country_of_birth_option_MC": "모나코",
  "country_of_birth_option_MN": "몽골리아",
  "country_of_birth_option_MS": "몬세 라트",
  "country_of_birth_option_MA": "모로코",
  "country_of_birth_option_MZ": "모잠비크",
  "country_of_birth_option_MM": "미얀마",
  "country_of_birth_option_NA": "나미비아의",
  "country_of_birth_option_NR": "나우루",
  "country_of_birth_option_NP": "네팔",
  "country_of_birth_option_NL": "네덜란드",
  "country_of_birth_option_AN": "네덜란드 령 앤 틸리 스",
  "country_of_birth_option_NC": "뉴 칼레도니아",
  "country_of_birth_option_NZ": "뉴질랜드",
  "country_of_birth_option_NI": "니카라과",
  "country_of_birth_option_NE": "니제르",
  "country_of_birth_option_NG": "나이지리아",
  "country_of_birth_option_NU": "썩은 것",
  "country_of_birth_option_NF": "노퍽 섬",
  "country_of_birth_option_MP": "북 마리아나 제도",
  "country_of_birth_option_NO": "노르웨이",
  "country_of_birth_option_OM": "오만",
  "country_of_birth_option_PK": "파키스탄",
  "country_of_birth_option_PW": "팔라우",
  "country_of_birth_option_PS": "팔레스타인 영토, 점령",
  "country_of_birth_option_PA": "파나마",
  "country_of_birth_option_PG": "파푸아 뉴기니",
  "country_of_birth_option_PY": "파라과이",
  "country_of_birth_option_PE": "페루",
  "country_of_birth_option_PH": "필리핀 제도",
  "country_of_birth_option_PN": "핏 케어",
  "country_of_birth_option_PL": "폴란드",
  "country_of_birth_option_PT": "포르투갈",
  "country_of_birth_option_PR": "푸에르토 리코",
  "country_of_birth_option_QA": "카타르",
  "country_of_birth_option_RE": "재결합",
  "country_of_birth_option_RO": "루마니아",
  "country_of_birth_option_RU": "러시아인",
  "country_of_birth_option_RW": "르완다",
  "country_of_birth_option_SH": "세인트 헬레나",
  "country_of_birth_option_KN": "세인트 키츠 네비스",
  "country_of_birth_option_LC": "세인트 루시아",
  "country_of_birth_option_PM": "세인트 피에르와 마네리몬",
  "country_of_birth_option_VC": "세인트 빈센트 그레나딘",
  "country_of_birth_option_WS": "사모아",
  "country_of_birth_option_SM": "산 마리노",
  "country_of_birth_option_ST": "상투 메 프린 시표",
  "country_of_birth_option_SA": "사우디 아라비아",
  "country_of_birth_option_SN": "세네갈",
  "country_of_birth_option_CS": "세르비아와 몬테네그로",
  "country_of_birth_option_SC": "세이셸",
  "country_of_birth_option_SL": "시에라 리온",
  "country_of_birth_option_SG": "싱가포르",
  "country_of_birth_option_SK": "슬로바키아",
  "country_of_birth_option_SI": "슬로베니아",
  "country_of_birth_option_SB": "솔로몬 제도",
  "country_of_birth_option_SO": "소말리아",
  "country_of_birth_option_ZA": "남아프리카",
  "country_of_birth_option_GS": "사우스 조지아와 남쪽 샌드위치 제도",
  "country_of_birth_option_ES": "스페인",
  "country_of_birth_option_LK": "스리랑카",
  "country_of_birth_option_SD": "수단",
  "country_of_birth_option_SR": "수리남",
  "country_of_birth_option_SJ": "Svalbard와 Jan Mayen.",
  "country_of_birth_option_SZ": "스와질란드",
  "country_of_birth_option_SE": "스웨덴",
  "country_of_birth_option_CH": "스위스",
  "country_of_birth_option_SY": "시리아 아랍 공화국",
  "country_of_birth_option_TW": "대만, 중국의 지방",
  "country_of_birth_option_TJ": "타지키스탄",
  "country_of_birth_option_TZ": "탄자니아, 유화",
  "country_of_birth_option_TH": "태국",
  "country_of_birth_option_TL": "티모르 - leste.",
  "country_of_birth_option_TG": "토고",
  "country_of_birth_option_TK": "tokelau.",
  "country_of_birth_option_TO": "통가",
  "country_of_birth_option_TT": "트리니다드 토바고",
  "country_of_birth_option_TN": "튀니지",
  "country_of_birth_option_TR": "칠면조",
  "country_of_birth_option_TM": "투르크 메니스탄",
  "country_of_birth_option_TC": "터키와 카이 코스 제도",
  "country_of_birth_option_TV": "투발루",
  "country_of_birth_option_UG": "우간다",
  "country_of_birth_option_UA": "우크라이나",
  "country_of_birth_option_AE": "아랍 에미리트",
  "country_of_birth_option_GB": "영국",
  "country_of_birth_option_US": "미국",
  "country_of_birth_option_UM": "미국 사소한 외딴 섬",
  "country_of_birth_option_UY": "우루과이",
  "country_of_birth_option_UZ": "우즈베키스탄",
  "country_of_birth_option_VU": "바누아투",
  "country_of_birth_option_VE": "베네수엘라",
  "country_of_birth_option_VN": "베트남",
  "country_of_birth_option_VG": "버진 아일랜드, 영국인",
  "country_of_birth_option_VI": "버진 아일랜드, 미국",
  "country_of_birth_option_WF": "월리스와 퓨 투나",
  "country_of_birth_option_EH": "서부 사하라",
  "country_of_birth_option_YE": "예멘",
  "country_of_birth_option_ZM": "잠비아",
  "country_of_birth_option_ZW": "짐바브웨",
  "gender_option_female": "여자",
  "gender_option_male": "남성",
  "gender_option_nonconf": "성성이 아닌 성향",
  "relationship_status_option_single": "하나의",
  "relationship_status_option_domestic_partner": "국내 파트너",
  "relationship_status_option_common_law": "관습법",
  "relationship_status_option_emancipated_minor": "해방 된 미성년자",
  "relationship_status_option_married": "기혼",
  "relationship_status_option_divorced": "이혼했다",
  "relationship_status_option_separated": "분리되어있다",
  "relationship_status_option_widowed": "미망인",
  "housing_option_own": "소유하다",
  "housing_option_room_in_apartment": "아파트의 방",
  "housing_option_friends_or_family": "친구 또는 가족",
  "housing_option_regular_rent": "정기 임대료",
  "housing_option_subsidized_rent": "보조금 임금",
  "housing_option_shelter": "대피소",
  "housing_option_homeless": "노숙자",
  "employment_option_full_time": "풀 타임",
  "employment_option_part_time": "파트 타임",
  "employment_option_unemployed": "한가한",
  "education_option_no_high_school": "고등학교 없음",
  "education_option_high_school_diploma": "고등학교 졸업장",
  "education_option_ged": "고초",
  "education_option_associate_or_bachelo": "준회원 또는 학사 학위",
  "education_option_post_graduate": "대학원 공부",
  "ethnicity_option_two_or_more_races": "둘 이상의 종족",
  "ethnicity_option_black": "블랙 (히스패닉이 아닌)",
  "ethnicity_option_white": "흰색 (히스패닉이 아닌)",
  "ethnicity_option_hispanic_or_latino": "히스패닉 또는 라티노",
  "ethnicity_option_asian_or_pacific": "아시아 또는 태평양 제도 주민",
  "ethnicity_option_american_indian_or_alaskan": "아메리칸 인디언 또는 알래스카",
  "ethnicity_option_other": "다른",
  "snap_benefits": "보충 영양 지원 프로그램",
  "wic_benefits": "여성, 유아 및 어린이를위한 보충 영양 프로그램",
  "tanf_benefits": "가난한 가족을위한 임시 지원",
  "medicaid_benefits": "낮은 수입을 가진 사람들을위한 공중 보건 보험",
  "ssi_benefits": "보충 보안 소득 프로그램",
  "free_reduced_meals": "무료 또는 감소 된 식사 프로그램",
  "tefap_form": "TEFAP 인증",
  "tefap_form_expired": "귀하의 TEFAP 증명서가 만료되었습니다",
  "tefap_form_usda_title": "USDA 차별금지 선언문",
  "tefap_form_usda_subheader": "다음 사항을 숙지하시기 바랍니다.",
  "tefap_form_usda_body": "<p>In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating in or administering USDA programs are prohibited from discriminating based on race, color, national origin, religion, sex, disability, age, marital status, family/parental status, income derived from a public assistance program, political beliefs, or reprisal or retaliation for prior civil rights activity, in any program or activity conducted or funded by USDA (not all bases apply to all programs). Remedies and complaint filing deadlines vary by program or incident.</p><p>Persons with disabilities who require alternative means of communication for program information (e.g., Braille, large print, audiotape, American Sign Language, etc.) should contact the State or local Agency that administers the program or contact USDA through the Telecommunications Relay Service at 711 (voice and TTY). Additionally, program information may be made available in languages other than English.</p><p>To file a program discrimination complaint, complete the USDA Program Discrimination Complaint Form, AD-3027, found online at <a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">How to File a Program Discrimination Complaint</a> and at any USDA office or write a letter addressed to USDA and provide in the letter all of the information requested in the form. To request a copy of the complaint form, call (866) 632-9992. Submit your completed form or letter to USDA by:</p><p>(1) mail: U.S. Department of Agriculture, Office of the Assistant Secretary for Civil Rights, 1400 Independence Avenue, SW, Mail Stop 9410, Washington, D.C. 20250-9410;</p><p>(2) fax: (202) 690-7442; or</p><p>(3) email: <a href=\"mailto:program.intake@usda.gov\">program.intake@usda.gov</a>.</p><p>USDA is an equal opportunity provider, employer, and lender.</p>",
  "app_button_next": "다음",
  "app_button_back": "뒤",
  "app_button_submit": "제출하다",
  "app_button_close": "닫다",
  "app_button_done": "완료",
  "form_required": "필수의 *",
  "benefits": "혜택 프로그램",
  "benefits_extra": "혜택 프로그램에 대한 세부 정보",
  "help_and_support": "우리는 당신을 도울 준비가 되어 있습니다",
  "help_and_support_extra": "자주 묻는 질문(FAQ) 및 연락처 정보",
  "frequently_asked_questions": "자주 묻는 질문",
  "contact_support": "풍부한 지원에 문의하세요",
  "optional_details": "선택적 세부 사항",
  "address_street_1": "주소",
  "address_street_2": "적절한",
  "city": "도시",
  "state": "상태",
  "zipcode": "우편 번호",
  "additional_optional_details": "추가 세부 사항",
  "gender": "성별",
  "relationship_status": "관계 상태",
  "ethnicity": "민족성",
  "country_of_birth": "출생 국가",
  "employment": "고용",
  "highest_education_obtained": "교육",
  "food_preferences": "음식 환경 설정",
  "housing_details": "주택 세부 사항",
  "housing_status": "주택 현황",
  "special_circumstances": "특별한 상황",
  "needs_assistance": "팬티에 도움이 필요해",
  "dont_need_assistance": "나는 팬티에 도움이 필요하지 않습니다",
  "aiq_validation_error_min_adult_family_members": "성인 가구 구성원은 0보다 커야 합니다.",
  "aiq_validation_error_max_adult_family_members": "성인 가구 구성원은 10명을 초과할 수 없습니다.",
  "aiq_validation_error_min_child_family_members": "자녀 가구 구성원은 0보다 커야 합니다.",
  "aiq_validation_error_max_child_family_members": "자녀 가구 구성원은 10명을 초과할 수 없습니다.",
  "aiq_validation_error_min_senior_family_members": "가구 구성원 중 상위 구성원은 0명보다 커야 합니다.",
  "aiq_validation_error_max_senior_family_members": "가구 구성원 중 상위 구성원은 10명을 초과할 수 없습니다.",
  "aiq_validation_error_required_emergency_contact": "비상 연락처 정보가 필요합니다",
  "aiq_validation_error_required_pick_up_name": "수령 담당자 이름 정보가 필요합니다.",
  "aiq_validation_error_required_birth_date": "생년월일 정보가 필요합니다",
  "aiq_validation_error_regex_zip_code": "우편번호는 숫자여야 합니다.",
  "aiq_validation_error_required_first_name": "이름은 필수 항목입니다.",
  "aiq_validation_error_required_last_name": "성은 필수 항목입니다.",
  "aiq_validation_error_min_baby_supplies": "유아용품은 0보다 커야 합니다.",
  "aiq_validation_error_max_baby_supplies": "유아용품은 10개를 초과할 수 없습니다.",
  "dietary_preferences_option_lactose": "락토오스 안내",
  "dietary_preferences_option_gluten": "글루텐 편협함",
  "dietary_preferences_option_kosher": "적법한",
  "dietary_preferences_option_halal": "할랄",
  "dietary_preferences_option_dairy_free": "유제품 무료",
  "dietary_preferences_option_vegetarian": "채식주의 자",
  "dietary_preferences_option_vegan": "채식주의 자의",
  "dietary_preferences_option_fodmap": "Fodmap.",
  "dietary_preferences_option_nut_allergy": "나무 너트와 땅콩 알레르기",
  "dietary_preferences_option_fish_allergy": "물고기와 조개류 알레르기",
  "dietary_preferences_option_none": "선호도가 없습니다",
  "tefap_additional_info_requested": "추가 정보 요청",
  "tefap_zipcode_correct": "우편 번호가 맞습니까?",
  "tefap_address_correct": "주소가 정확합니까?",
  "tefap_participate_in_programs": "귀하의 가구 중 어느 누구도 다음 프로그램에 참여합니까?",
  "tefap_check_all_that_apply": "해당되는 것을 모두 선택해 주세요. 없는 경우 다음을 탭하여 추가 옵션을 확인하세요.",
  "tefap_household_numbers_correct": "귀하의 가정에서의 사람들의 수가 올바른가요?",
  "tefap_household_dont_include_yourself": "이 화면에 자신을 포함시키지 마십시오. TEFAP에서는 전체 가구 규모만 요구하지만 Plentiful에서는 이전에 제공한 정보를 표시합니다.",
  "tefap_income_at_or_below_question": "귀하의 소득이 있거나 그 아래에 있습니다",
  "tefap_for_household_size": "귀하의 가구를 위해",
  "tefap_retake_attestation": "당신은 증명을 다시 시작하고 싶습니까?",
  "tefap_attestation_completed": "TEFAP 증명 양식을 성공적으로 완료했습니다.",
  "tefap_thank_you": "고맙습니다!",
  "tefap_is_recorded": "귀하의 TEFAP 증명서가 기록되었습니다. 프로필에서 그것을 다시 retake 할 수 있습니다.",
  "tefap_sign_below": "귀하의 이름 (선택 사항)",
  "tefap_legal_signing": "아래에 서명함으로써 모든 출처의 소득이 내 가구와 동일한 수의 사람들이 가정에서 나열된 수입을 초과하지 않거나이 양식을 체크 한 프로그램에 참여하는 가정에서 위에 나열된 수입을 초과하지 않는다고 선언합니다. 이 기록은이 유통 사이트에서 자신감이 있음을 이해하지만 뉴욕 주립 공무원 또는 미국 농업 부서에서 요청시 검토를 위해 공개 될 수 있습니다.",
  "tefap_retake": "다시 잡다",
  "program_complete_now": "지금 완료",
  "program_complete_later": "나중에 완료하십시오",
  "reservation_confirmed": "방문확인",
  "tefap_reservation_confirmed": "귀하의 방문이 확인되었습니다!",
  "pre_registration_confirmed": "방문확인",
  "your_upcoming_reservation": "다가오는 방문",
  "your_upcoming_pre_registration": "다가오는 방문",
  "tefap_attestation_needed": "이 식료품 저장실은 TEFAP 증명을 요청하고 있습니다.",
  "tefap_attestation_complete_now": "지금 완성하고 다음 식료품 저장실 방문시 시간을 절약하십시오.",
  "tefap_description": "USDA는 긴급 식량 지원 프로그램(TEFAP)을 통해 지역 사회에 식량 지원을 제공하고 무료 급식소 및 식품 저장실과 같은 지역 사회 기관을 통해 이를 이용할 수 있도록 합니다.",
  "tefap_what_is_tefap": "tefap이란 무엇입니까?",
  "tefap_confirm_share_with_pantry": "이 정보 저장실로 다음 정보를 공유 하려는지 확인하십시오.",
  "tefap_thanks_for_sharing": "식료품 저장실이 요청한 추가 정보를 제공해 주셔서 감사합니다!",
  "tefap_continue_make_reservation": "계속해서 방문 일정을 계획하세요",
  "tefap_pantry_is_requesting": "이 식료품 저장실이 귀하의 요청을 요청하고 있습니다",
  "tefap_missing_information": "없는 정보",
  "tefap_pantry_will_ask": "지금 이 정보를 추가하려면 '다음'을 클릭하세요. 건너뛰시면 다음 방문 시 식료품 저장실에서 해당 정보를 요청합니다.",
  "tefap_submission_pending": "답변을 식품 저장실에 제출하는 중...",
  "cancel_edit": "편집 취소",
  "edit": "편집하다",
  "select": "고르다",
  "can_prepare_food": "음식을 준비 할 수 있습니다",
  "cannot_prepare_food": "음식을 준비 할 수 없다",
  "pantry_details_prompt_title": "{{programName}} 필요",
  "pantry_details_prompt_without_visit_label": "이 푸드뱅크는 등록을 위해 {{programName}}을 사용합니다. 푸드뱅크에 도착하면 추가 질문에 답변해야 합니다.",
  "pantry_details_prompt_visit_label": "이 푸드뱅크는 등록을 위해 {{programName}}을 사용합니다. 온라인으로 이 질문들에 답변하여 다음 방문 시간을 절약하세요.",
  "state_program_attestation_cannot_complete": "죄송하지만, 현재 귀하의 증명을 완료할 수 없습니다. 나중에 다시 시도하시거나, 지원팀에 문의하시거나, 식료품 저장실에 도착했을 때 이를 완료하실 수 있습니다.",
  "state_program_attestation_submitted": "{{programName}} 증명을 완료해 주셔서 감사합니다! 귀하의 답변이 식료품 저장실에 성공적으로 제출되었습니다. 이것은 {{programName}} 질문의 끝이며, 다른 추가 질문은 다른 Plentiful 프로그램에서 나옵니다.",
  "state_program_cancel_confirmation": "{{programName}}에 대한 증명을 취소하시겠습니까? 식료품 저장실을 방문할 때 이러한 질문에 여전히 답해야 할 수도 있습니다.",
  "state_program_cancel_attestation": "증명 취소",
  "state_program_resume_attestation": "증명 계속",
  "tefap_no_submit": "아니, 제출",
  "tefap_yes_retake": "예, 다시 테이크",
  "tefap_expires": "만료",
  "tefap_incomplete": "미완료, 다음 식료품 저장실 방문 시 시간을 절약하려면 지금 완료하세요.",
  "tefap_none": "없음",
  "tefap_benefit_programs_select": "다음 프로그램에서 등록을 선택하십시오",
  "tefap_pantry_requests_info": "이 식료품 저장실은 다가오는 방문을위한 추가 정보를 요청합니다.",
  "tefap_eligible": "당신은 자격이 있습니다",
  "tefap_not_eligible": "당신은 자격이 없습니다",
  "tefap_receive_product": "TEFAP 제품을 받으려면",
  "tefap_eligible_program": "다음과 같은 프로그램에 참여합니다",
  "tefap_eligible_programs": "다음 프로그램에 참여합니다",
  "tefap_not_eligible_program": "어떤 프로그램에도 참여하지 않습니다",
  "tefap_household_income": "귀하의 가계 수입",
  "tefap_info_changed": "TEFAP 자격 정보 (혜택 프로그램, 가구 크기 및 / 또는 소득에 참여)가 최근 변경 되었습니까?",
  "tefap_still_get_food": "식료품 저장실에서 비TEFAP 식품을 계속 받으실 수 있습니다.",
  "tefap_form_checking_here": "여기에서 확인하면 다음이 사실임을 증명합니다.",
  "tefap_form_checking_1": "1. 위에 제공된 수령인의 이름, 주소 및 가정 크기가 정확합니다.",
  "tefap_form_checking_2_CO": "2. 수령인은 콜로라도에 거주합니다(최소 거주 기간 필요 없음).",
  "tefap_form_checking_2_NY": "2. 수령인은 뉴욕 주 내에 상주합니다 (최소한의 거주의 길이가 필요 없음).",
  "tefap_form_checking_3": "3. 수신자는 위의 TEFAP 자격 지침의 옵션 1 및 / 또는 옵션 2를 충족합니다.",
  "tefap_form_checking_4": "4.이 음식은 수령인의 가정 소비만을위한 것이며, 판매, 거래 또는 물물 교환되지 않습니다.",
  "tefap_form_checking_5_1": "5. 수령인은",
  "tefap_form_checking_5_2": "USDA Nondiscrimination 진술.",
  "tefap_out_of_state": "당신은 다른 상태에 살고 있습니다",
  "and": "그리고",
  "or": "또는",
  "exceeds": "아래가 아닙니다",
  "not_exceeds": "초과하지 않습니다",
  "people": "사람들",
  "person": "사람",
  "because": "왜냐하면",
  "custom_field_first_name": "이름",
  "custom_field_last_name": "성",
  "custom_field_contact_info": "연락처 정보",
  "custom_field_birth_date": "생일",
  "custom_field_zip_code": "우편 번호",
  "custom_field_household_size": "주택 크기",
  "custom_field_food_pickup": "픽업 대표",
  "custom_field_emergency_contact": "긴급 연락처",
  "custom_field_address": "주소",
  "custom_field_needs_assistance": "특별한 상황 (도움이 필요함)",
  "custom_field_benefits_programs": "혜택 프로그램",
  "custom_field_tefap_income_eligibility": "Tefap 소득 자격",
  "custom_field_relationship_status": "관계 상태",
  "custom_field_ethnicity": "민족성",
  "custom_field_education": "가장 높은 교육을 받았습니다",
  "custom_field_dietary_preferences": "식이 환경 설정",
  "custom_field_gender": "성별",
  "custom_field_country_of_birth": "출생 국가",
  "custom_field_employment": "고용",
  "custom_field_food_preparation": "음식을 준비 할 수 있습니다",
  "custom_field_housing": "주택 현황",
  "search": "검색 (팬트리 이름, 우편번호, 도시, 주)",
  "all": "모두",
  "pantry_filter_program_type": "프로그램 유형",
  "pantry_filter_program_type_non-food": "비식품",
  "pantry_filter_program_type_foodpantry": "식품 저장실(무료 식료품)",
  "pantry_filter_program_type_soupkitchen": "수프 키친(따뜻한 식사 무료 제공)",
  "pantry_filter_status": "상태",
  "pantry_filter_status_all": "모두",
  "pantry_filter_status_opennow": "지금 열다",
  "pantry_filter_status_opentoday": "오늘 오픈",
  "pantry_filter_status_openthisweek": "이번주 오픈",
  "pantry_filter_status_other": "다른",
  "pantry_filter_pantry_type": "식료품 저장실 유형",
  "pantry_filter_pantry_type_plentifulpantry": "풍부한 식료품 저장실",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "검증된 파트너 식품 저장실",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "확인되지 않은 파트너 식료품 저장실",
  "search_no_results_found": "결과를 찾을 수 없습니다",
  "search_no_pantries_match": "\"{query}\"과(와) 일치하는 식품 저장실이 없습니다",
  "search_try_searching_by": "다음으로 검색해 보세요:",
  "search_suggestion_city": "도시 이름 (예: \"브루클린\")",
  "search_suggestion_city_accessibility": "도시 이름, 예를 들어 브루클린",
  "search_suggestion_zipcode": "우편번호 (예: \"10001\")",
  "search_suggestion_zipcode_accessibility": "우편번호, 예를 들어 10001",
  "search_suggestion_pantry_name": "식품 저장실 이름",
  "search_suggestion_street_address": "거리 주소",
  "search_accessibility_no_results": "{query}에 대한 결과를 찾을 수 없습니다. 도시 이름, 우편번호, 식품 저장실 이름 또는 거리 주소로 검색해 보세요.",
  "search_accessibility_no_results_generic": "결과를 찾을 수 없습니다. 도시 이름, 우편번호, 식품 저장실 이름 또는 거리 주소로 검색해 보세요.",
  "search_accessibility_no_results_sites": "{query}에 대한 결과를 찾을 수 없습니다. 식품 저장실 이름 또는 도시로 검색해 보세요.",
  "search_accessibility_no_results_sites_generic": "결과를 찾을 수 없습니다. 식품 저장실 이름 또는 도시로 검색해 보세요.",
  "search_error_unable_to_display": "검색 결과를 표시할 수 없습니다",
  "search_error_occurred": "검색 결과를 표시하는 동안 오류가 발생했습니다. 다시 검색해 주세요.",
  "search_results_truncated": "상위 결과를 보여드리고 있습니다. 원하는 것을 찾지 못하셨다면 다른 검색어로 다시 시도해 보세요.",
  "accessibility_phone": "전화: {phone}",
  "accessibility_email": "이메일: {email}",
  "accessibility_website": "웹사이트: {website}",
  "pantry_filter_service_type": "서비스 종류",
  "pantry_filter_service_type_line": "라인 기반",
  "pantry_filter_service_type_pre-registration": "사전등록",
  "pantry_filter_service_type_qr-code": "QR 코드 체크인",
  "pantry_filter_service_type_reservation": "예약",
  "program_type_benefit_enrollment": "혜택 등록",
  "program_type_emergency_services": "긴급 서비스",
  "program_type_non_plentiful_pantry": "비 유능한 식료품 저장실",
  "program_type_other_services": "기타 서비스",
  "program_type_plentiful_pantry": "풍부한 식료품 저장실",
  "program_type_shelter": "대피소",
  "program_type_soup_kitchen": "수프 주방",
  "service_restriction_none": "제한 없음",
  "service_restriction_seniors": "노인 만",
  "service_restriction_families_with_children": "자녀 만있는 가족",
  "service_restriction_new_clients": "새로운 고객 만",
  "service_restriction_existing_clients": "기존 클라이언트 만",
  "filter_by_category": "카테고리 별 필터",
  "opted_out": "귀하의 전화 번호가 SMS를 선택하여 로그인 코드를 보낼 수없는 것 같습니다. START 에게 726879로 문자를 보내서 다시 시도한 다음 다시 시도하십시오.",
  "miles_away_singular": "%s 마일 떨어져 있습니다",
  "miles_away_plural": "%s 마일 떨어져 있습니다",
  "today": "오늘",
  "address_autocomplete_placeholder": "제안 사항을 보려면 입력을 시작하세요",
  "push_notification_permissions_denied": "푸시 알림에 대한 권한이 부여되지 않았습니다. 시스템 설정을 열고 푸시 알림을 활성화하세요.",
  "push_notification_setup_error": "푸시 알림을 설정하는 중 오류가 발생했습니다.",
  "push_notification_alternate_notifications": "SMS나 이메일을 통해 계속 알림을 받으실 수 있습니다.",
  "loading_message": "가까운 식품 저장고 찾기",
  "location_services_no_access": "Plentiful이 기기의 위치 정보에 접근할 수 없는 것 같습니다. 브라우저 또는 기기 설정에서 Plentiful의 위치 서비스를 활성화해 주세요.",
  "error_screen_header": "아차! 오류가 발생했습니다.",
  "error_screen_message": "예상치 못한 문제가 발생했습니다. 앱을 다시 시작하거나 지원팀에 문의하세요.",
  "update_available_header": "업데이트 사용 가능",
  "update_available_message": "최신 버전을 불러오려면 다시 시작하세요.",
  "restart_app": "앱 다시 시작",
  "email_support": "이메일 지원",
  "map_zoom_to_see_all": "모든 위치를 보려면 확대하세요",
  "program_eligible": "귀하는 {{program}} 프로그램에 참여할 자격이 있습니다.",
  "program_ineligible": "귀하는 {{program}} 프로그램에 참여할 자격이 없습니다. 이유: {{reason}}",
  "program_not_applicable": "{{program}}을(를) 완료했습니다.",
  "program_completed": "모든 {{program}} 질문을 완료했습니다.",
  "program_unknown_eligibility": "양식을 작성해 주셔서 감사합니다. 담당자가 도착하시면 자격 요건을 확인해 드릴 것입니다.",
  "site_map_error_title": "문제가 발생했습니다",
  "site_map_error_message": "지도를 불러올 수 없습니다. 다시 시도해 주세요.",
  "site_map_load_error_title": "사이트를 불러올 수 없습니다",
  "site_map_load_error_message": "이 지역을 불러오는 중 문제가 발생했습니다. 다시 시도해 주세요.",
  "site_map_retry": "다시 시도",
  "site_list_search_placeholder": "Search pantry name, ZIP, city",
  "site_list_result_count": "{{count}}곳",
  "site_list_result_count_one": "{{count}}곳",
  "site_list_result_count_zero": "장소를 찾을 수 없습니다",
  "site_list_today": "Today",
  "site_list_tomorrow": "Tomorrow",
  "site_list_status_open_until": "Open now until {{time}}",
  "site_list_status_open_now": "지금 영업 중",
  "site_list_status_closed_next_open": "Closed now · next open {{day}} {{time}}",
  "site_list_status_no_upcoming": "No upcoming services",
  "site_list_status_more_available": "추가 시간이 있을 수 있습니다 · 식품 저장실에 문의하세요",
  "site_list_booking_walkin": "Walk in",
  "site_list_booking_reservation": "Reservation",
  "site_list_booking_preregistration": "Pre-registration",
  "site_list_booking_unknown": "알 수 없음",
  "site_list_more_times": "+ more times available",
  "site_list_default_event_name": "Food Distribution",
  "site_list_unconfirmed_title": "Hours not confirmed",
  "site_list_unconfirmed_body": "We list this place from a partner directory but don't have its current times. Call before you go.",
  "site_list_timezone_note": "{{zone}} 기준으로 표시된 시간",
  "site_details_upcoming_events_heading": "다가오는 서비스",
  "site_details_reserve_cta": "시간 예약하기",
  "site_details_plan_visit_cta": "방문 계획하기",
  "site_details_no_upcoming_events": "예정된 서비스가 없습니다",
  "site_details_timezone_note": "{{zone}} 기준으로 표시된 시간",
  "site_details_more_windows": "+ 추가 이용 가능 시간",
  "site_details_event_name_fallback": "배포",
  "site_details_slot_picker_no_times": "이용 가능한 시간이 없습니다",
  "site_details_slot_full": "마감",
  "site_details_availability_as_of": "{{time}} 기준 예약 가능 여부",
  "site_details_availability_error": "시간 정보를 불러오지 못했습니다. 다시 시도해 주세요."
}
